// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailsBg {
  width: 60%;
  min-height: 60%;
  max-height: 85%;
  background-color: var(--Foreground);
  border-radius: 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  opacity: 1;
  position: absolute;
  transition: all 0.7s ease-out;
  overflow: auto;
}
.detailsBg form {
  gap: 1.25rem;
  width: 100%;
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.detailsBg form .uploadsContainer {
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  overflow: auto;
}
.detailsBg form .uploadsContainer input, .detailsBg form .uploadsContainer select {
  width: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid var(--Stroke);
  background-color: transparent;
  text-indent: 0.6rem;
  min-height: 2.5rem;
  color: var(--TextColor);
  font-size: 0.875rem;
}
.detailsBg form .uploadsContainer h3 {
  color: var(--TextColor);
  width: 100%;
  font-size: 1.125rem;
}
.detailsBg form .uploadsContainer span {
  width: 100%;
  font-size: 0.75rem;
  color: var(--TextColor);
  text-wrap: balance;
}
.detailsBg form .uploadsContainer .Ensure {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: var(--TextColor);
  cursor: pointer;
}
.detailsBg form .uploadsContainer .Ensure input {
  min-width: 1rem;
  min-height: 1rem;
  max-width: 1rem;
  max-height: 1rem;
}
.detailsBg form .uploadsContainer .Ensure div {
  display: flex;
  flex-direction: column;
}
.detailsBg form .uploadsContainer .Ensure div span {
  font-size: 0.625rem;
  font-weight: 400;
  color: var(--TextColor);
  opacity: 0.6;
  text-wrap: pretty;
  margin-top: 0.5rem;
}
.detailsBg form .uploadsContainer .Ensure div a {
  text-decoration: none;
  opacity: 1;
  color: var(--AccentColor);
}
.detailsBg form .uploadsContainer .AddDocumentsContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  margin-bottom: 1rem;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument {
  width: calc(100% - 0.5rem);
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.625rem;
  border-radius: 0.75rem;
  overflow: auto;
  border: 0.125rem dashed var(--Stroke);
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .TitleHint {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .TitleHint h3 {
  width: 100%;
  font-size: 1rem;
  font-weight: 700;
  color: #818181;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .TitleHint p {
  font-size: 0.625rem;
  font-weight: 400;
  color: #818181;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .TitleHint span {
  font-weight: 700;
  color: #818181;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .FileName {
  flex: 1 1;
  word-break: break-all;
  hyphens: auto;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .FileName a {
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--AccentColor);
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .UploadButton {
  min-width: 6rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: var(--AccentColor);
  color: #ffffff;
  font-size: 0.75rem;
  cursor: pointer;
}
.detailsBg form .uploadsContainer .AddDocumentsContainer .AddDocument .UploadButton input {
  display: none;
}
.detailsBg form .uploadsContainer .uploadDiv, .detailsBg form .uploadsContainer .uploadedDiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem;
  border-radius: 0.6rem;
  border: 1px dashed rgba(0, 0, 0, 0.5);
}
.detailsBg form .uploadsContainer .uploadDiv:not(.uploadDiv), .detailsBg form .uploadsContainer .uploadedDiv:not(.uploadDiv) {
  border-style: solid;
}
.detailsBg form .uploadsContainer .uploadDiv div, .detailsBg form .uploadsContainer .uploadedDiv div {
  width: 100%;
}
.detailsBg form .uploadsContainer .uploadDiv div .fileName, .detailsBg form .uploadsContainer .uploadedDiv div .fileName {
  opacity: 1;
}
.detailsBg form .uploadsContainer .uploadDiv div h2, .detailsBg form .uploadsContainer .uploadedDiv div h2 {
  font-size: 0.8rem;
  color: var(--TextColor);
  opacity: 0.6;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detailsBg form .uploadsContainer .uploadDiv div h2 span, .detailsBg form .uploadsContainer .uploadedDiv div h2 span {
  font-size: 0.6rem;
  font-weight: 500;
}
.detailsBg form .uploadsContainer .uploadDiv div p, .detailsBg form .uploadsContainer .uploadedDiv div p {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.6;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detailsBg form .uploadsContainer .uploadDiv .uploadBtn, .detailsBg form .uploadsContainer .uploadedDiv .uploadBtn {
  width: min-content;
}
.detailsBg form .uploadsContainer .uploadDiv .uploadBtn button, .detailsBg form .uploadsContainer .uploadedDiv .uploadBtn button {
  width: min-content;
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 0.2rem;
  margin: 0;
}
.detailsBg form .uploadsContainer .uploadDiv .uploadBtn input, .detailsBg form .uploadsContainer .uploadedDiv .uploadBtn input {
  display: none;
}
.detailsBg h1 {
  font-size: 1.5rem;
  font-weight: 600;
  width: 100%;
  text-align: center;
  color: var(--TextColor);
}
.detailsBg button {
  margin-top: 0.6rem;
  width: 80%;
  border: none;
  outline: none;
  background-color: var(--AccentColor);
  color: white;
  border-radius: 0.3rem;
  padding: 1rem 0rem;
  font-size: 1rem;
  font-weight: 600;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.detailsBg.active {
  z-index: 1;
}
.detailsBg.active button {
  visibility: visible;
}
.detailsBg.next {
  position: absolute;
  opacity: 0.3;
  transform: translate(0, 9%) scale(0.8);
  background-color: var(--Foreground);
  border-radius: 1.25rem;
}
.detailsBg.secondNext {
  position: absolute;
  opacity: 0.3;
  transform: translate(0, 17%) scale(0.7);
  background-color: var(--Foreground);
  border-radius: 1.25rem;
}

.modal {
  display: flex; /* Show the modal */
  position: fixed;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 20px;
  border: 1px solid #888;
  max-height: 80%;
  padding-top: 40px;
  position: relative;
}
.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.close {
  color: #aaa;
  text-align: right;
  font-size: 28px;
  position: absolute;
  font-weight: bold;
  top: 0;
  right: 10px;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Components/CompanyRegistration/Info/Forms/BusinessDetails.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,eAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;AACJ;AAAI;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAEN;AADM;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAGR;AAFQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sCAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AAFQ;EACE,uBAAA;EACA,WAAA;EACA,mBAAA;AAIV;AAFQ;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AAIV;AAFQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAIV;AAHU;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAKZ;AAHU;EACE,aAAA;EACA,sBAAA;AAKZ;AAJY;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAMd;AAJY;EACE,qBAAA;EACA,UAAA;EACA,yBAAA;AAMd;AAFQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AAIV;AAHU;EACE,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;EACA,qCAAA;AAKZ;AAJY;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAMd;AALc;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAOhB;AALc;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAOhB;AALc;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAOhB;AAJY;EACE,SAAA;EACA,qBAAA;EACA,aAAA;AAMd;AALc;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAOhB;AAJY;EACE,eAAA;EACA,YAAA;EACA,qBAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAMd;AALc;EACE,aAAA;AAOhB;AAFQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AAIZ;AAFY;EACI,mBAAA;AAIhB;AADY;EACI,WAAA;AAGhB;AAFgB;EACI,UAAA;AAIpB;AADgB;EACI,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGpB;AAFoB;EACI,iBAAA;EACA,gBAAA;AAIxB;AAAgB;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEpB;AAEY;EACI,kBAAA;AAAhB;AACgB;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;AACpB;AAEgB;EACI,aAAA;AAApB;AASI;EACI,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AAPR;AASI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR;AAUI;EACI,UAAA;AARR;AASQ;EACI,mBAAA;AAPZ;AAWI;EACI,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,mCAAA;EACA,sBAAA;AATR;AAYI;EACI,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,mCAAA;EACA,sBAAA;AAVR;;AAeA;EACI,aAAA,EAAA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EAEA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;AAbJ;;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,sBAAA;EAEA,aAAA;EACA,sBAAA;EAEA,eAAA;EACA,iBAAA;EACA,kBAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBN;;AAoBE;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,MAAA;EACA,WAAA;AAjBJ;;AAoBE;;EAEE,YAAA;EACA,qBAAA;EACA,eAAA;AAjBJ","sourcesContent":[".detailsBg{\n    width: 60%;\n    min-height : 60%;\n    max-height : 85%;\n    background-color: var(--Foreground);\n    border-radius: .6rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n    align-items: center;\n    justify-content: center;\n    padding: 1.25rem;\n    opacity: 1;\n    position: absolute;\n    transition: all 0.7s ease-out;\n    overflow: auto;\n    form{\n      gap: 1.25rem;\n      width: 100%;\n      flex: 1;\n      overflow: auto;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-evenly;\n      align-items: center;\n      .uploadsContainer {\n        width: 90%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.8rem;\n        overflow: auto;\n        input, select{\n            width: 100%;\n            border: none;\n            outline: none;\n            border-bottom: 1px solid var(--Stroke);\n            background-color: transparent;\n            text-indent: .6rem;\n            min-height: 2.5rem;\n            color: var(--TextColor);\n            font-size: 0.875rem;\n        }\n        h3{\n          color: var(--TextColor);\n          width: 100%;\n          font-size: 1.125rem;\n        }\n        span{\n          width: 100%;\n          font-size: 0.75rem;\n          color: var(--TextColor);\n          text-wrap: balance;\n        }\n        .Ensure{\n          width: 100%;\n          display: flex;\n          align-items: flex-start;\n          gap: 0.5rem;\n          font-size: 0.75rem;\n          color: var(--TextColor);\n          cursor: pointer;\n          input{\n            min-width: 1rem;\n            min-height: 1rem;\n            max-width: 1rem;\n            max-height: 1rem;\n          }\n          div{\n            display: flex;\n            flex-direction: column;\n            span{\n              font-size: 0.625rem;\n              font-weight: 400;\n              color: var(--TextColor);\n              opacity: 0.6;\n              text-wrap: pretty;\n              margin-top: 0.5rem;\n            }\n            a{\n              text-decoration: none;\n              opacity: 1;\n              color: var(--AccentColor);\n            }\n          }\n        }\n        .AddDocumentsContainer{\n          display: flex;\n          flex-direction: column;\n          width: 100%;\n          gap: 1rem;\n          margin-bottom: 1rem;\n          .AddDocument{\n            width: calc(100% - 0.5rem);\n            display: flex;\n            align-items: center;\n            gap: 1rem;\n            padding: 0.5rem 0.625rem;\n            border-radius: 0.75rem;\n            overflow: auto;\n            border: 0.125rem dashed var(--Stroke);\n            .TitleHint{\n              flex: 1;\n              display: flex;\n              flex-direction: column;\n              overflow: auto;\n              h3{\n                width: 100%;\n                font-size: 1rem;\n                font-weight: 700;\n                color: #818181;\n              }\n              p{\n                font-size: 0.625rem;\n                font-weight: 400;\n                color: #818181;\n              }\n              span{\n                font-weight: 700;\n                color: #818181;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n            }\n            .FileName{\n              flex: 1;\n              word-break: break-all;\n              hyphens: auto;\n              a{\n                text-decoration: none;\n                font-size: 0.875rem;\n                font-weight: 700;\n                color: var(--AccentColor);\n              }\n            }\n            .UploadButton{\n              min-width: 6rem;\n              height: 2rem;\n              border-radius: 0.5rem;\n              background: var(--AccentColor);\n              color: #ffffff;\n              font-size: 0.75rem;\n              cursor: pointer;\n              input{\n                display: none;\n              }\n            }\n          }\n        }\n        .uploadDiv, .uploadedDiv {\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            padding: 0.6rem;\n            border-radius: 0.6rem;\n            border: 1px dashed rgba(0, 0, 0, 0.5);\n    \n            &:not(.uploadDiv) {\n                border-style: solid;\n            }\n    \n            div {\n                width: 100%;\n                .fileName {\n                    opacity: 1;\n                }\n    \n                h2 {\n                    font-size: 0.8rem;\n                    color: var(--TextColor);\n                    opacity: 0.6;\n                    font-weight: 600;\n                    white-space: nowrap;       \n                    overflow: hidden;          \n                    text-overflow: ellipsis;    \n                    span {\n                        font-size: 0.6rem;\n                        font-weight: 500;\n                    }\n                }\n    \n                p {\n                    font-size: 0.8rem;\n                    font-weight: 500;\n                    opacity: 0.6;\n                    color: var(--TextColor);\n                    white-space: nowrap;       \n                    overflow: hidden;          \n                    text-overflow: ellipsis;    \n                }\n            }\n    \n            .uploadBtn {\n                width: min-content;\n                button {\n                    width: min-content;\n                    padding: 0.5rem 1rem;\n                    font-size: 0.8rem;\n                    font-weight: 500;\n                    border-radius: 0.2rem;\n                    margin: 0;\n                }\n    \n                input {\n                    display: none;\n                }\n            }\n        }\n    }\n    }\n    \n    \n\n    h1{\n        font-size: 1.5rem;\n        font-weight: 600;\n        width: 100%;\n        text-align: center;\n        color: var(--TextColor);\n    }\n    button{\n        margin-top: .6rem;\n        width: 80%;\n        border: none;\n        outline: none;\n        background-color: var(--AccentColor);\n        color: white;\n        border-radius: .3rem;\n        padding: 1rem 0rem;\n        font-size: 1rem;\n        font-weight: 600;\n        visibility: hidden;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &.active{\n        z-index: 1;\n        button{\n            visibility: visible;\n        }\n    }\n\n    &.next{\n        position: absolute;\n        opacity: .3;\n        transform: translate(0, 9%) scale(0.8);\n        background-color: var(--Foreground);\n        border-radius: 1.25rem;\n    }\n\n    &.secondNext{\n        position: absolute;\n        opacity: .3;\n        transform: translate(0, 17%) scale(0.7);\n        background-color: var(--Foreground);\n        border-radius: 1.25rem;\n    }\n}\n\n\n.modal {\n    display: flex; /* Show the modal */\n    position: fixed;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    // padding-top: 60px;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n  \n  .modal-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    background-color: #fff;\n    // margin: 5% auto;\n    padding: 20px;\n    border: 1px solid #888;\n    // width: 80%;\n    max-height: 80%;\n    padding-top: 40px;\n    position: relative;\n    // overflow: hidden;\n    img{\n      max-width: 100%;\n      max-height: 100%;\n      object-fit: contain;\n    }\n  }\n  \n  .close {\n    color: #aaa;\n    text-align: right;\n    font-size: 28px;\n    position: absolute;\n    font-weight: bold;\n    top: 0;\n    right: 10px;\n  }\n  \n  .close:hover,\n  .close:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
